import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import axios from "axios";
import config from "../../../config";
import authHeader from "../../Authentication/authHeader";
import Swal from "sweetalert2";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import ExpenseModal from "./ExpenseModal";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

export default function ExpenseList() {
  dayjs.extend(utc);
  dayjs.extend(timezone);
  const TIMEZONE = "Asia/Dhaka";

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const [centerList, setCenterList] = useState([]);
  const [expenseList, setExpenseList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [visibility, setVisibility] = useState(false);
  const [userProfile, setUserProfile] = useState(
    JSON.parse(localStorage.getItem("userProfile")),
  );
  const [selectedDateRange, setSelectedDateRange] = useState(null);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [expenseLoading, setExpenseLoading] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [isView, setIsView] = useState(false);
  const [selectedExpenseData, setSelectedExpenseData] = useState(null);

  const handleExpenseDateRage = (value) => {
    if (Array.isArray(value) && value.length === 2 && value[0] && value[1]) {
      let startDate = dayjs.tz(value[0], TIMEZONE).startOf("day");
      let endDate = dayjs.tz(value[1], TIMEZONE).endOf("day");
      console.log("startDate: ", startDate);
      console.log("endDate: ", endDate);
      const formattedStartDate = startDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]",
      );
      const formattedEndDate = endDate.format(
        "ddd, DD MMM YYYY HH:mm:ss [GMT+6]",
      );

      setSelectedDateRange([formattedStartDate, formattedEndDate]);
    } else {
      setSelectedDateRange(null);
    }
  };

  const handleCenter = (value) => {
    setCurrentPage(1);
    setSelectedCenter(value);
  };
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const handleExpenseModalVisibility = () => {
    setVisibility(true);
  };

  const handleExpenseModalClose = () => {
    setVisibility(false);
    setIsUpdate(false);
    setIsView(false);
    setSelectedExpenseData(null);
  };

  const handleUpdateExpenseModalVisibility = (record) => {
    setVisibility(true);
    setIsUpdate(true);
    setSelectedExpenseData(record);
  };

  const handleViewExpenseModalVisibility = (record) => {
    setVisibility(true);
    setIsView(true);
    setSelectedExpenseData(record);
  };

  const fetchExpenseList = () => {
    setExpenseLoading(true);
    axios
      .get(`${config.baseUrl}/budget/expense_list/`, {
        headers: authHeader(),
        params: {
          center_id: selectedCenter,
          dateRange: selectedDateRange,
          page: currentPage,
        },
      })
      .then((response) => {
        setExpenseLoading(false);
        setExpenseList(response?.data?.results);
        setTotalItems(response?.data?.count);
      })
      .catch((error) => {
        setExpenseLoading(false);
        console.log(error);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  };
  useEffect(() => {
    fetchExpenseList();
  }, [currentPage, selectedCenter, selectedDateRange]);

  useEffect(() => {
    setExpenseLoading(true);
    axios
      .get(`${config.baseUrl}/inventory/center_list/`, {
        headers: authHeader(),
      })
      .then((response) => {
        setExpenseLoading(false);
        setCenterList(response?.data);
      })
      .catch((error) => {
        setExpenseLoading(true);
        Swal.fire({
          title: "Error",
          text: error,
          confirmButtonText: "Ok",
          icon: "error",
        });
      });
  }, []);

  const expenseColumn = [
    {
      title: "Date",
      render: (record) =>
        record?.created_at
          ? new Date(record?.created_at).toISOString().slice(0, 10)
          : "",
      width: "8%",
    },
    {
      title: "Center",
      render: (record) => record?.center?.name,
      width: "10%",
    },
    {
      title: "Prepared By",
      render: (record) => record?.prepared_by?.prepared_by_name,
      width: "10%",
    },

    {
      title: "Total Expense Amount",
      dataIndex: "total_expense_amount",
      width: "10%",
    },
    {
      title: "Checked By",
      render: (record) => record?.checked_by?.checked_by_name,
      width: "8%",
    },
    {
      title: "Status",
      render: (record) => record?.status,
      width: "8%",
    },
    {
      title: "Remarks",
      render: (record) => record?.remarks,
      width: "10%",
    },

    {
      title: "Action",
      width: "5%",
      render: (record) => {
        return (
          <React.Fragment>
            <div className="d-flex">
              <Tooltip title="Update">
                <Button
                  size="small"
                  disabled={record?.status === "Checked" ? true : false}
                  className="d-flex align-items-center me-1"
                  onClick={() => handleUpdateExpenseModalVisibility(record)}
                >
                  <EditOutlined />
                </Button>
              </Tooltip>
              <Tooltip title="View">
                <Button
                  size="small"
                  className="d-flex align-items-center"
                  onClick={() => handleViewExpenseModalVisibility(record)}
                >
                  <EyeOutlined />
                </Button>
              </Tooltip>
            </div>
          </React.Fragment>
        );
      },
    },
  ];
  return (
    <>
      {visibility && (
        <ExpenseModal
          visible={visibility}
          modalClose={handleExpenseModalClose}
          userProfile={userProfile}
          isUpdate={isUpdate}
          isView={isView}
          data={selectedExpenseData}
          fetchExpenseList={fetchExpenseList}
        />
      )}
      <div className="farmerDashboard">
        <div className="dashboardNameSection">
          <h5 style={{ color: "#46604A" }}>EXPENSE LIST</h5>
        </div>
        <div className="farmerDashboardContainer shadow-sm rounded">
          <div className="pt-5" style={{ width: "95%", margin: "auto" }}>
            <div className="shadow-sm p-3">
              <div className="m-2 mt-4 d-flex justify-content-between align-items-center">
                <div>
                  <Select
                    placeholder="Select Center"
                    className="me-3"
                    onChange={handleCenter}
                    style={{ width: "200px" }}
                  >
                    <Option value="">All Center</Option>
                    {centerList?.map((center) => (
                      <Option
                        value={center?.center?.employee_id}
                        key={center?.center?.employee_id}
                      >
                        {center?.center_name}
                      </Option>
                    ))}
                  </Select>

                  <RangePicker
                    onChange={handleExpenseDateRage}
                    value={
                      selectedDateRange
                        ? selectedDateRange.map((date) => dayjs(date))
                        : null
                    }
                    style={{ width: "250px" }}
                  />
                </div>

                <Button
                  style={{
                    backgroundColor: "#46604A",
                    borderColor: "#46604A",
                    color: "white",
                  }}
                  onClick={handleExpenseModalVisibility}
                >
                  Add Expense
                </Button>
              </div>
              <Table
                className="border"
                size="small"
                columns={expenseColumn}
                dataSource={expenseList}
                loading={expenseLoading}
                rowKey={(record) => record?.expense_id}
                pagination={{
                  current: currentPage,
                  pageSize: 10,
                  total: totalItems,
                  onChange: handlePageChange,
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
